import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import {
  columnLabelDotSx,
  columnLabelStackSx,
  columnLabelTypographySx,
} from './ScannerAnimation.styles';

export function ColumnLabel({ children }: { children: ReactNode }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.75}
      sx={columnLabelStackSx}>
      <Box sx={columnLabelDotSx} />
      <Typography sx={columnLabelTypographySx}>{children}</Typography>
    </Stack>
  );
}
